export default __webpack_public_path__ + "static/media/select-radio-empty.70d20361.svg";